<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import config from '../../../../../../configHttp';
import { inquiryAnalisiscode, deleteTCode, loadTcode, saveOrUpdateTcode, getindexofCACodeDesc, inquiryAliasConfig, importanalysiscode } from '../../../../../api/home.js';
import uploadFileplus from '../../../../common/uploadFileplus/index.vue';
export default {
	name: 'AnalysisCode',
	components: {
		uploadFileplus
	},
	data() {
		return {
			updiag: false,
			uploadinglist: [],
			uploadingdata: {},
			/* 搜索栏 */
			searchlist: getdata().searchlist,
			searchdata: getdata().searchdata,
			overlength: 0,
			searchdiag: false,
			/* 搜索栏 */
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('AnalysisCodeheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('AnalysisCodeoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			tableHeight: 'calc(100vh - 325px )',
			/* 表格 */
			//分析代码
			fxdm: [],
			//弹框
			scope: '1',
			analyse: false,
			involveMapping: [],
			settingEnable: [],
			FormData: {
				involveMapping: '',
				settingEnable: '',
				mappingType: '2',
				tcode: '',
				refCode: '',
				refCodeDesc: '',
				accountDesc: '',
				lastAccountCode: '',
				lastAccountDesc: '',
				bijfs: '',
				quzfw: '0',
				input1: '',
				input2: '',
				refAccountCode: '',
				activeStartDate: '',
				activeEndDate: ''
			},
			ystypexl: [{ label: '分析代码对应到一级科目', value: '2' }, { label: '分析代码对应到末级科目', value: '3' }, { label: '非映射分析代码', value: '1' }],
			title: '新增分析代码',
			rules: {
				tcode: [{ required: true, message: '请选择分析代码', trigger: 'blur' }]
			},
			Count: 0,
			sort: '',
			order: ''
		};
	},
	created() {
		this.searrchForData();
	},
	mounted() {},
	methods: {
		sortchange(data) {
			this.sort = data.prop;
			this.order = data.order == 'ascending' ? 'asc' : 'desc';
			this.searrchForData();
		},
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('AnalysisCodeoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('AnalysisCodeheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//分析代码导出
		derivedData() {
			let params = {};
			if (this.$refs.tablebox.getSelectionval().length == 0) {
				params = JSON.stringify(this.searchdata);
			} else {
				params = JSON.stringify({
					ids: this.$refs.tablebox
						.getSelectionval()
						.map(v => v.id)
						.join(',')
				});
			}
			let req = {
				downUrl: config.baseURL + '/fvm/analysiscode/Export',
				typeObj: {
					toForm: false,
					fileType: 'xls',
					fileName: '分析代码' + this.$timestampToStr(new Date(), 'yyyyMMdd')
				},
				params: params
			};
			this.$downloadcommon(req);
		},
		forsubmit(e) {
			if (this.$emptyandnull(this.upfile.upfilename)) {
				this.$message.error('请选择要上传的文件');
				return false;
			}
			let params = {};
			params.analysiscodeUploadFile = this.upfile.upfile;
			importanalysiscode(params).then(res => {
				if (res.data.code == '200') {
					this.closeupdiag();
					this.searrchForData();
					this.$message.success('导入成功');
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		closeupdiag() {
			this.updiag = false;
		},
		getuploadparams(e) {
			this.upfile = e;
		},
		//科目输入框搜索
		querySearchAsync(queryString, cb) {
			let params = {};
			params.q = queryString;
			getindexofCACodeDesc(params).then(res => {
				if (res.data.code == '200') {
					let data = [];
					data = JSON.parse(res.data.data);
					cb(
						data.map(v => {
							return {
								key: v.key,
								value: v.key+"-"+v.value
							};
						})
					);
				}
			});
		},
		//搜索后选择
		handleSelect(e) {
			this.FormData.refAccountCode = e.key;
			this.FormData.accountDesc = e.value.substring(e.value.indexOf('-')+1,e.value.length);
		},
		//删除
		deleteTCode(id) {
			if (this.$refs.tablebox.getSelectionval().length == 0 && id == '-1') {
				this.$message.error('请选择要删除的数据');
				return;
			}
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					let params = {};
					if (id != '-1') {
						params.ids = id;
					} else {
						params.ids = this.$refs.tablebox
							.getSelectionval()
							.map(v => v.id)
							.join(',');
					}

					deleteTCode(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		//唤起新增修改弹框
		analysetkuan(id) {
			if (id == '-1') {
				this.title = '新增分析代码';
				this.$nextTick(() => {
					this.settingEnable = [' '];
					this.involveMapping = [' '];
				});
				this.FormData = {
					id: id,
					involveMapping: '',
					settingEnable: '',
					mappingType: '2',
					tcode: '',
					refCode: '',
					refCodeDesc: '',
					accountDesc: '',
					lastAccountCode: '',
					lastAccountDesc: '',
					bijfs: '0',
					quzfw: '0',
					input1: '',
					input2: '',
					refAccountCode: '',
					activeStartDate: '',
					activeEndDate: ''
				};
				this.analyse = true;
			} else {
				this.title = '编辑分析代码';
				this.FormData.isNew = true;
				let params = { id: id };
				loadTcode(params).then(res => {
					if (res.data.code == '200') {
						this.FormData = res.data.data;
						this.FormData.activeStartDate = this.formatDate(this.FormData.activeStartDate);
						this.FormData.activeEndDate = this.formatDate(this.FormData.activeEndDate);
						if (res.data.data.quzfw == '1') {
							this.FormData.input1 = this.FormData.dataScope.split(',')[0];
							this.FormData.input2 = this.FormData.dataScope.split(',')[1];
							// this.FormData.dataScope = this.FormData.input1 + ',' + this.FormData.input2;
						}

						this.analyse = true;
					}
				});
			}
			this.$nextTick(() => {
				this.$refs['FormData'].clearValidate();
			});
		},
		formatDate(value) {
			// 时间戳转换日期格式方法
			if (value == null) {
				return '';
			} else {
				const date = new Date(value);
				const y = date.getFullYear(); // 年
				let MM = date.getMonth() + 1; // 月
				MM = MM < 10 ? '0' + MM : MM;
				let d = date.getDate(); // 日
				d = d < 10 ? '0' + d : d;
				return y + '-' + MM + '-' + d;
			}
		},
		//最后的保存
		analysebc() {
			this.$refs.FormData.validate(valid => {
				if (valid) {
					let params = {};

					if (this.FormData.mappingType == '2') {
						this.FormData.lastAccountCode = '';
						this.FormData.lastAccountDesc = '';
					} else if (this.FormData.mappingType == '3') {
						this.FormData.accountDesc = '';
						this.FormData.refAccountCode = '';
					} else if (this.FormData.mappingType == '1') {
						this.FormData.accountDesc = '';
						this.FormData.activeStartDate = '';
						this.FormData.bijfs = '';
						this.FormData.involveMapping = '';
						this.involveMapping = [];
						this.FormData.settingEnable = '';
						this.settingEnable = [];

						this.FormData.lastAccountCode = '';
						this.FormData.lastAccountDesc = '';
						this.FormData.quzfw = '';
						this.FormData.refAccountCode = '';
						this.FormData.activeEndDate = '';
					}

					if (this.involveMapping.length == 0) {
						this.FormData.involveMapping = '0';
					} else {
						this.FormData.involveMapping = '1';
					}
					if (this.settingEnable.length == 0) {
						this.FormData.settingEnable = '0';
					} else {
						this.FormData.settingEnable = '1';
					}

					if (this.FormData.quzfw == '1') {
						this.FormData.dataScope = this.FormData.input1 + ',' + this.FormData.input2;
					}
					params.data = JSON.stringify(this.FormData);
					saveOrUpdateTcode(params).then(res => {
						if (res.data.code == '200') {
							this.analyse = false;
							this.searrchForData();
							this.$message.success('保存成功');
						} else {
							this.$message.error(res.data.message);
						}
					});
				} else {
					return false;
				}
			});
		},
		searrchForData() {
			let params = {
				page: this.pagination.pageNum,
				rows: this.pagination.pageSize,
				sort: this.sort,
				order: this.order,
				criteriaJson: JSON.stringify(this.searchdata)
			};
			inquiryAnalisiscode(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
					inquiryAliasConfig().then(res1 => {
						if (res1.data.code == '200') {
							this.fxdm = [];
							for (var i in res1.data.data) {
								if (i.substring(0, 5) == 'tcode' && this.$notemptyandnull(res1.data.data[i]) && i.length < 10) {
									this.fxdm.push({ label: res1.data.data[i], value: i.slice(5) });
								}
							}
							this.searchlist = getdata().searchlist;
							this.searchlist[0].selectval = this.fxdm;
						}
					});
				}
			});
		},
		/* 搜索栏 */
		geOoverLength(e) {
			this.overlength = e;
		},
		submitSearch() {
			this.pagination.pageNum = 1;
			this.pagination.paginationkey++;
			this.searrchForData();
		},
		forUpdateSearch() {
			this.searchdiag = true;
		},
		closeSearch() {
			this.searchdiag = false;
		},
		saveChange(e) {
			this.searchdiag = false;
		},
		/* 搜索栏 */
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
